module.exports = __webpack_public_path__ + "img/toleft.f0917d6b.png";